import axios from './axios'


export function post(data) {
    return axios({
        url: 'url',
        method: 'post',
        data
    })
}

// 登录相关

// 验证码
export function captcha(data) {
    return axios({
        url: '/user/sendCaptcha',
        method: 'post',
        data
    })
}
// 修改登录密码
export function userChangePassword(data) {
    return axios({
        url: '/user/changePassword',
        method: 'post',
        data
    })
}
// 找回密码
export function userResetPassword(data) {
    return axios({
        url: '/user/resetPassword',
        method: 'post',
        data
    })
}
// 注册
export function register(data) {
    return axios({
        url: '/user/register',
        method: 'post',
        data
    })
}




//账号密码登录
export function passLogin(data) {
    return axios({
        url: '/user/login',
        method: 'post',
        data
    })
}


// 获取个人信息
export function getUser() {
    return axios({
        url: '/user/getUserInfo',
        method: 'post'
    })
}

// 退出登录
export function out() {
    return axios({
        url: '/loginOut',
        method: 'post'
    })
}

// steam登录
export function steam(data) {
    return axios({
        url: '/login/steam',
        method: 'post',
        data
    })
}

// steam登录后设置信息
export function updateInfo(data) {
    return axios({
        url: '/update/info',
        method: 'post',
        data
    })
}


//富文本
export function constantsGet(data) {
    return axios({
        url: '/constants/get',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

